import { useEffect, useState } from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from "@chakra-ui/react";
import { Installment } from "@/models/proposal.model";
import { BrlCurrencyFormatter } from "@/utils/BrlCurrencyFormatter";
import { format } from "date-fns";

type InstallmentTableProps = {
  installments: Installment[];
};

export default function InstallmentTable({
  installments,
}: InstallmentTableProps) {
  const [displayedInstallments, setDisplayedInstallments] = useState<
    { dueDate: string; amortization: number }[]
  >([]);

  useEffect(() => {
    const { filteredInstallments } = installments.reduce(
      (acc, installment) => {
        const { payment } = installment;

        if (payment <= 0) {
          return acc;
        }

        const updatedInstallment = {
          ...installment,
          amortization: payment,
        };

        acc.filteredInstallments.push(updatedInstallment);
        acc.totalAmortization += payment;

        return acc;
      },
      {
        totalAmortization: 0,
        filteredInstallments: [] as Installment[],
      }
    );

    setDisplayedInstallments(filteredInstallments);
  }, [installments]);

  return (
    <Table variant="simple" colorScheme="blue">
      <Thead bg="secondary" color="white">
        <Tr>
          <Th textAlign="center" color="white">
            Ano
          </Th>
          <Th textAlign="center" color="white">
            Valor
          </Th>
        </Tr>
      </Thead>
      <Tbody>
        {displayedInstallments.map((installment, index) => (
          <Tr key={index}>
            <Td textAlign="center">
              {format(new Date(installment.dueDate), "dd/MM/yyyy")}
            </Td>
            <Td textAlign="center">
              {BrlCurrencyFormatter(installment.amortization)}
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
}
